import GraphQLError from './GraphQLError';
import useGraphQLClient from './useGraphQLClient';
/**
 * Returns a function that executes a GraphQL mutation.
 *
 * @template TResult The expected result type of the mutation.
 * @template TVariables The expected variables type of the mutation.
 * @param {string} query The GraphQL query string.
 * @param {object} [options] The options for the mutation.
 * @param {GraphQLClient} [options.client] The client to use for the mutation.
 * @param {TVariables} [options.variables] The variables to use for the mutation.
 * @param {string} [options.operationName] The name of the operation to use for the mutation.
 * @param {object} [options.extensions] Additional extensions to add to the mutation.
 * @returns {Array<Function>} A function that executes the mutation.
 */
var useMutation = function (query, options) {
    var client = useGraphQLClient(options && options.client, options && options.guest);
    /**
     * Executes the mutation with the specified variables.
     *
     * @param {object} [options2] The options for the mutation.
     * @param {TVariables} [options2.variables] The variables to use for the mutation.
     * @returns {Promise<IQueryResult<TResult>>} A promise that resolves to the result of the mutation.
     */
    var ret = function (options2) {
        return client.ExecuteQueryRaw({
            query: query,
            variables: ((options2 === null || options2 === void 0 ? void 0 : options2.variables) || (options === null || options === void 0 ? void 0 : options.variables)),
            operationName: options && options.operationName,
            extensions: options && options.extensions,
        }).result.then(function (data) {
            if (data.data && !(data.errors && data.errors.length))
                return Promise.resolve(data);
            return Promise.reject(new GraphQLError(data));
        });
    };
    return [ret];
};
export default useMutation;
